import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

import { computed, inject, watch } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'user-part-select',
  props: {
  modelValue: {
    type: [String, Number]
  },
  userTypeId: {
    type: String,
    default: '1'
  },
  deptList: {
    type: Array as any,
    default: () => []
  },
  roleList: {
    type: Array as any,
    default: () => []
  },
  posList: {
    type: Array as any,
    default: () => {
      return []
    }
  }
},
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

const props = __props
const optionsObj = {
  2: props.deptList,
  3: props.posList,
  4: props.roleList
}
const holderObj = {
  2: '请选择部门',
  3: '请选择岗位',
  4: '请选择角色'
}

const userPartChange: any = inject('userPartChange')

const emits = __emit

const realValue = computed(() => {
  return props.modelValue
})
const placeholder = computed(() => {
  return holderObj[props.userTypeId]
})
const optionsList = computed(() => {
  return optionsObj[props.userTypeId]
})
const optionLabel = computed(() => {
  if (props.userTypeId === '3') {
    return 'postName'
  } else if (props.userTypeId === '4') {
    return 'roleName'
  }
  return ''
})
watch(() => props.userTypeId, () => {
  emits('update:modelValue', '')
})

const selectChange = (data: any) => {
  console.log('selectChange', data)
  emits('update:modelValue', data)
  userPartChange(props.userTypeId, data)
}

return (_ctx: any,_cache: any) => {
  const _component_el_tree_select = _resolveComponent("el-tree-select")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (__props.userTypeId === '2')
    ? (_openBlock(), _createBlock(_component_el_tree_select, {
        key: 0,
        modelValue: realValue.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((realValue).value = $event)),
        placeholder: placeholder.value,
        data: optionsList.value,
        filterable: "",
        "check-strictly": "",
        onChange: selectChange
      }, null, 8, ["modelValue", "placeholder", "data"]))
    : (_openBlock(), _createBlock(_component_el_select, {
        key: 1,
        placeholder: placeholder.value,
        modelValue: realValue.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((realValue).value = $event)),
        onChange: selectChange,
        teleported: false
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(optionsList.value, (item) => {
            return (_openBlock(), _createBlock(_component_el_option, {
              key: item.id,
              label: item[optionLabel.value],
              value: item.id
            }, null, 8, ["label", "value"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["placeholder", "modelValue"]))
}
}

})